import type { ComponentType } from 'react';
import { Navigate, type RouteObject } from 'react-router';

/**
 * Маршрути розділу «Процеси й регламенти» (/kb/registry/…), шляхи відносні до /kb.
 * Сторінки завантажуються ліниво; картки процесу, документа й статті — окремі сторінки з глибоким посиланням.
 */
const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

export const registryRoutes: RouteObject[] = [
  {
    path: 'registry',
    ...page(() => import('./RegistryLayout')),
    children: [
      { index: true, element: <Navigate to="processes" replace /> },
      { path: 'processes', ...page(() => import('./processes/ProcessesPage')) },
      { path: 'processes/:processId', ...page(() => import('./processes/ProcessPage')) },
      { path: 'documents', ...page(() => import('./documents/DocumentsPage')) },
      { path: 'documents/:documentId', ...page(() => import('./documents/DocumentPage')) },
      { path: 'acknowledgements', ...page(() => import('./acknowledgements/AcknowledgementsPage')) },
      { path: 'questions', ...page(() => import('./governance/QuestionsPage')) },
      { path: 'decisions', ...page(() => import('./governance/DecisionsPage')) },
      { path: 'contradictions', ...page(() => import('./governance/ContradictionsPage')) },
      { path: 'positions', ...page(() => import('./positions/PositionsPage')) },
      { path: 'glossary', ...page(() => import('./glossary/GlossaryPage')) },
      { path: 'articles', ...page(() => import('./articles/ArticlesPage')) },
      { path: 'articles/:articleId', ...page(() => import('./articles/ArticlePage')) },
      { path: 'update-requests', ...page(() => import('./updates/UpdateRequestsPage')) },
      { path: 'search', ...page(() => import('./search/SearchPage')) },
      { path: 'settings', ...page(() => import('./settings/SettingsPage')) },
    ],
  },
];
